import React, { useState, useEffect } from 'react';
import Carousel from './Carousel';
import CnnHeadlines from './CnnHeadlines';
import './NewsFeed.css';

const NewsFeed = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_ENDPOINT = 'https://cbn006qu37.execute-api.us-east-1.amazonaws.com/feeds';
  //const API_ENDPOINT = 'https://localhost:5001/feeds';

  useEffect(() => {
    const fetchFeeds = async () => {
      try {
        const response = await fetch(API_ENDPOINT);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        console.log('API Response:', data); // Debug log
        
        // Handle both PascalCase (old) and camelCase (new ASP.NET Core)
        const articlesWithDates = data
          .map(article => ({
            title: article.title || article.Title,
            link: article.link || article.Link,
            description: article.description || article.Description,
            imageUrl: article.imageUrl || article.ImageUrl,
            source: article.source || article.Source,
            pubDate: new Date(article.pubDate || article.PubDate)
          }))
          .filter(article => article.imageUrl && article.description);
        
        console.log('Processed articles:', articlesWithDates.length); // Debug log
        setArticles(articlesWithDates);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching feeds:', err);
        setError('Failed to load news feeds. Please try again later.');
        setLoading(false);
      }
    };

    fetchFeeds();
  }, []);

  if (loading) {
    return (
      <div className="news-feed">
        <div className="loading">Loading news articles...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="news-feed">
        <div className="error">{error}</div>
      </div>
    );
  }

  // Separate CNN articles from others
  const cnnArticles = articles.filter(article => article.source === 'CNN').slice(0, 5);
  const nonCnnArticles = articles.filter(article => article.source !== 'CNN');
  
  // First 4 non-CNN articles for carousel
  const carouselArticles = nonCnnArticles.slice(0, 4);
  // Rest for grid
  const gridArticles = nonCnnArticles.slice(4);

  return (
    <div className="news-feed">
      <div className="hero-section">
        <div className="hero-main">
          {carouselArticles.length > 0 && (
            <Carousel articles={carouselArticles} />
          )}
        </div>
        <div className="hero-sidebar">
          {cnnArticles.length > 0 && (
            <CnnHeadlines articles={cnnArticles} />
          )}
        </div>
      </div>
      
      <div className="news-grid">
        {gridArticles.map((article, index) => (
          <a
            key={index}
            href={article.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-card"
          >
            {article.imageUrl && (
              <div className="news-image">
                <img src={article.imageUrl} alt={article.title} />
              </div>
            )}
            <div className="news-content">
              <div className="news-source">{article.source}</div>
              <h3 className="news-title">{article.title}</h3>
              <p className="news-description">{article.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default NewsFeed;
